<div class="standalone-payment theme-interface" [ngStyle]="isIOSApp ? {'position': 'relative',
    'max-height': '100vh',
    'overflow-y': 'scroll',
    'overflow-x': 'hidden',
    'padding-bottom': '130px'} : {}"
    [ngStyle]="storeSettings?.PAYMENT_ABA_PAYWAY_CREDIT_CARD_ENABLED ? { 'padding-bottom': '0px' } : { 'padding-bottom': '0px' }">
    <div #contentHeader class="content-header">
        <div class="store-info store-pd position-relative mx-auto theme-light">
          <!-- Main header row -->
          <div class="header-main-row">
            <!-- Left: Back arrow -->
            <div class="header-icon">
              <a href="#" class="close-details d-flex arrow-icon container-theme-light-icons round-background" (click)="onGoBack($event)">
                <i class="fa fa-arrow-left m-auto"></i>
              </a>
            </div>
            
            <!-- Center: Title and description -->
            <div class="header-center-content text-center">
              <div class="font-size-header font-weight-bold theme-light-header">
                {{'public.standalonepayment.paymentpage.title' | translate}}
              </div>
              <div class="store-title d-block mt-2 font-size-primary theme-light-subtitle">
                {{(selectedStore$ | async)?.name}} <span *ngIf="(selectedStore$ | async)?.description">|</span>
                {{(selectedStore$ | async)?.description}}
              </div>
            </div>
            
            <!-- Right: Language selector -->
            <div class="header-language">
              <app-store-catalog-language-selector [haveBackground]="false"></app-store-catalog-language-selector>
            </div>
          </div>
        </div>
        <div class="pb-2 bg-white" style="height: 20px;"></div>
      </div>
    <div *ngIf="error" class="mx-auto p-3 mb-0 pl-4 order-paid">
        <div class="font-size-primary text-unselectable">{{'public.standalonepayment.paymentpage.voucherError' |
            translate}}</div>
    </div>
    <app-loading-panel class="loading-panel" *ngIf="isLoading || !paymentData" [hideText]="true"
        [showLoading]="true"></app-loading-panel>
    <div class="d-flex w-100 justify-content-center py-3 py-lg-0" *ngIf="paymentData?.storeLogo">
        <img [src]="paymentData.storeLogo" class="logo" />
    </div>
    <div *ngIf="errorOrders" class="mx-auto p-3 mb-0 pl-4 order-paid">
        <div class="font-size-primary text-unselectable">{{'public.standalonepayment.paymentpage.orderError' |
            translate}}</div>
    </div>
    <div *ngIf="!error" class="mx-auto my-2 font-weight-bold order-location-info">
        <div *ngIf="(order?.location && showTable)" class="mx-3 theme-color-header">
            <span *ngIf="storeLocationType === LocationType.ROOM" class="font-size-header">
                {{'public.checkout.yourRoom' | translate}}
            </span>
            <span *ngIf="storeLocationType === LocationType.POLE" class="font-size-header">
                {{'public.checkout.yourPole' | translate}}
            </span>
            <span *ngIf="storeLocationType === LocationType.SEAT" class="font-size-header">
                {{'public.checkout.yourSeat' | translate}}
            </span>
            <span *ngIf="storeLocationType === LocationType.SUNBED" class="font-size-header">
                {{'public.checkout.yourSunbed' | translate}}
            </span>
            <span *ngIf="storeLocationType === LocationType.UMBRELLA" class="font-size-header">
                {{'public.checkout.yourUmbrella' | translate}}
            </span>
            <span *ngIf="storeLocationType === LocationType.SOFA" class="font-size-header">
                {{'public.checkout.yourSofa' | translate}}
            </span>
            <span *ngIf="storeLocationType === LocationType.AIRBNB" class="font-size-header">
                {{'public.checkout.yourAirbnb' | translate}}
            </span>
            <span *ngIf="storeLocationType === LocationType.LOCATION" class="font-size-header">
                {{'public.checkout.yourLocation' | translate}}
            </span>
            <span *ngIf="storeLocationType === LocationType.TABLE" class="font-size-header">
                {{'public.checkout.yourTable' | translate}}
            </span>
            <i class="fas fa-map-marker-alt mr-1 theme-color-icon"></i> <span
                class="font-size-primary">{{order?.location}}</span>
        </div>
        <div *ngIf="(order?.orderToken && showOrderToken)" class="my-2 mx-3">
            <span class="section-title">
                {{'public.thankyou.yourOrderNumber' | translate}}
            </span>
            <span class="section-title">{{" " + order?.orderToken}}</span>
        </div>
    </div>

<div class="content mx-auto item-content">
<div class="item-left cart-content" [style.top.px]="contentHeaderHeight" *ngIf="!isLoading && paymentData">
                    <div class="section-title p-3 mb-0 pl-4 font-size-primary font-weight-bold theme-light">
                        {{'public.standalonepayment.yourOrderAmount' | translate}}</div>
       
            <div *ngIf="isAmountReferenceOrder && paymentData"
                class="form-info mx-auto p-3 mb-0 pl-4 d-flex justify-content-between mt-2 mb-2 font-weight-bold theme-color-header">
                <span>{{'public.standalonepayment.paymentpage.amount' | translate}}</span>
                <span>{{paymentData.formattedAmountReference}}</span>
            </div>
        

    <div *ngIf="!error && !isAmountReferenceOrder && !errorOrders" class="card-body order-details mx-auto overflow-auto">
        <div class="content mx-auto pt-md-4">
            <div class="item-list px-lg-3" *ngIf="orderItems.length">
                <ng-container *ngFor="let item of orderItems; last as isLastItem">
                    <div class="item-wrapper d-flex flex-row mb-4"
                        [ngClass]="(!shouldDisplayTotal() && isLastItem) ? 'no-border-bottom' : ''">
                        <div class="qty font-size-primary font-weight-bold theme-color-header"
                            *ngIf="item.hierarchyLevel === 'PARENT'">
                            <span>{{item.quantity}} x</span>
                        </div>
                        <div class="item flex-fill mb-3">
                            <div class="p-0 mb-0 item-name">
                                <span
                                    class="theme-color-header font-size-primary font-weight-bold">{{item.itemName}}</span>
                                <span class="text-nowrap font-size-primary"
                                    *ngIf="paymentData && item.offerPrice && isShowParentItemPrice(item)">(
                                    {{item.offerPrice | formatPrice:
                                    paymentData.locale:paymentData.currencyIsoCode:paymentData.currencySymbol}}
                                    )</span>
                            </div>
                            <div class="item-specs p-0 mb-0 font-size-primary" *ngIf="item.priceDescription">
                                <span>{{item.priceDescription}}</span>
                            </div>
                            <ng-container>
                                <div class="item-specs p-0 mb-0" *ngIf="paymentData && item.discountValue">
                                    <span class="discount font-size-primary"
                                        *ngIf="item.discountType==='MONETARY'">{{'public.global.discount' | translate}}
                                        (- {{
                                        item.discountValue | formatPrice:
                                        paymentData.locale:paymentData.currencyIsoCode:paymentData.currencySymbol}}
                                        )</span>
                                    <span class="discount font-size-primary"
                                        *ngIf="item.discountType==='PERCENTILE'">{{'public.global.discount' |
                                        translate}} (- {{
                                        item.offerPrice * item.discountValue / 100 | formatPrice:
                                        paymentData.locale:paymentData.currencyIsoCode:paymentData.currencySymbol}}
                                        )</span>
                                    <span class="discount-percentage font-size-primary"
                                        *ngIf="item.discountType==='PERCENTILE'">-{{item.discountValue}}%</span>
                                </div>
                                <div class="item-specs p-0 mb-0" *ngIf="paymentData && item.childOrderItems?.length">
                                    <div *ngFor="let childItem of item.childOrderItems">
                                        <div>
                                            <span class="theme-color-header font-size-primary font-weight-bold">
                                                {{childItem.quantity > 1 ? childItem.quantity + ' x' : ''}}
                                                {{childItem.itemName}}
                                            </span>
                                            <span class="font-size-primary" *ngIf="childItem.offerPrice">(
                                                {{childItem.offerPrice | formatPrice:
                                                paymentData.locale:paymentData.currencyIsoCode:paymentData.currencySymbol}}
                                                )</span>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                            <div class="item-specs p-0 mb-0" *ngIf="item.comment">
                                <span>"{{item.comment}}"</span>
                            </div>
                        </div>
                        <div class="price text-right font-size-primary"
                            *ngIf="item.hierarchyLevel === 'PARENT' || item.hierarchyLevel === 'RULE'">
                            <div [ngClass]="{'striked':item.totalDiscountedPrice}"
                                *ngIf="paymentData && item.totalNonDiscountedPrice !== 0">
                                {{item.totalNonDiscountedPrice | formatPrice:
                                paymentData.locale:paymentData.currencyIsoCode:paymentData.currencySymbol}}</div>
                            <div *ngIf="paymentData && item.totalDiscountedPrice && item.totalDiscountedPrice > 0">
                                {{item.totalDiscountedPrice | formatPrice:
                                paymentData.locale:paymentData.currencyIsoCode:paymentData.currencySymbol}}
                            </div>
                        </div>
                    </div>
                </ng-container>
                <div *ngIf="order.serviceChargeAmount && order.deliveryMethod === 'IN_STORE_LOCATION'"
                    class="cart-total-wrapper d-flex flex-row">
                    <div class="total flex-fill theme-color-header">
                        {{'admin.store.serviceCharge' | translate}} ({{order.serviceChargePercentage}}%)
                    </div>
                    <div class="price-normal text-right">
                        {{ order.serviceChargeAmount | formatPrice:
                        paymentData.locale:paymentData.currencyIsoCode:paymentData.currencySymbol
                        }}
                    </div>
                </div>
                <div class="cart-total-wrapper d-flex flex-row"
                    *ngIf="paymentData && order.transactionFee && shouldDisplayTotal()">
                    <div class="total flex-fill theme-color-header">{{'public.global.transaction.fee' | translate}}</div>
                    <div class="price-normal text-right">{{order.transactionFee | formatPrice:
                        paymentData.locale:paymentData.currencyIsoCode:paymentData.currencySymbol}}</div>
                </div>
                <div class="cart-total-wrapper d-flex flex-row"
                    *ngIf="paymentData && order.deliveryFee && shouldDisplayTotal()">
                    <div class="total flex-fill theme-color-header">{{'public.checkout.deliveryFee' | translate}}</div>
                    <div class="price-normal text-right">{{order.deliveryFee | formatPrice:
                        paymentData.locale:paymentData.currencyIsoCode:paymentData.currencySymbol}}</div>
                </div>
                <div class="cart-total-wrapper d-flex flex-row"
                    *ngIf="paymentData && order.voucherDiscount && shouldDisplayTotal()">
                    <div class="total discount font-size-primary theme-color-header"
                        [ngClass]="{'flex-fill': order.voucherDiscountType !== 'PERCENTILE'}">
                        {{'public.global.discount' | translate}}
                        <span class="font-size-primary font-weight-normal pr-1">[{{order.voucherCode}}]</span>
                        <span class="font-size-primary font-weight-normal">(- {{order.voucherDiscount | formatPrice:
                            paymentData.locale:paymentData.currencyIsoCode:paymentData.currencySymbol}})</span>
                    </div>
                    <div class="total flex-fill discount-percentage font-size-primary"
                        *ngIf="order.voucherDiscountType === 'PERCENTILE'">
                        -{{order.voucherDiscountPercentage}}%
                    </div>
                    <div class="price-normal text-right font-size-primary">- {{order.voucherDiscount | formatPrice:
                        paymentData.locale:paymentData.currencyIsoCode:paymentData.currencySymbol}}</div>
                </div>
                <div class="cart-total-wrapper mb-3 d-flex flex-row" *ngIf="paymentData && shouldDisplayTotal()">
                    <div class="total flex-fill font-size-primary theme-color-header">{{'public.checkout.total' |
                        translate}}</div>
                    <div class="price text-right font-size-primary theme-color-header"
                        *ngIf="paymentData && order.formattedTotalDiscountedPrice; else showNonDiscountedPrice">
                        {{order.totalDiscountedPrice | formatPrice:
                        paymentData.locale:paymentData.currencyIsoCode:paymentData.currencySymbol}}
                    </div>
                    <ng-template #showNonDiscountedPrice>
                        <div class="price text-right font-size-primary theme-color-header">
                            {{order.totalNonDiscountedPrice | formatPrice:
                            paymentData.locale:paymentData.currencyIsoCode:paymentData.currencySymbol}}
                        </div>
                    </ng-template>
                </div>
            </div>
            <!-- <div class="option-wrapper" *ngIf="order.comment">
        <div class="variant-wrapper my-2">
            <div class="px-lg-3 my-3 store-note section-title font-weight-bold">{{'admin.store.note'|translate}}
            </div>
            <div class="mx-3 row">
                <span class="col-md-12 pl-0">{{ order.comment }}</span>
            </div>
        </div>
    </div> -->
        </div>
        <div class="print-space"></div>



    </div>
    <app-standalone-payment-information class="amount-right" *ngIf="(paymentData && isAmountRemaining)" [paymentData]="paymentData">
    </app-standalone-payment-information>

  </div>
  <div class="item-right">
    <app-standalone-payment-paid-amount *ngIf="!error"></app-standalone-payment-paid-amount>
    <app-standalone-payment-divide-amount *ngIf="(paymentData && isAmountRemaining)" [paymentData]="paymentData"
        [currencySymbol]="currencySymbol" [selectedStore]="selectedStore"
        [order]="order"></app-standalone-payment-divide-amount>
    <app-standalone-payment-tip *ngIf="(paymentData && isAmountRemaining)" [paymentData]="paymentData"
        [currencySymbol]="currencySymbol"></app-standalone-payment-tip>
    <app-standalone-payment-information class="amount-left" *ngIf="(paymentData && isAmountRemaining)" [paymentData]="paymentData">
    </app-standalone-payment-information>
    <div *ngIf="storeSettings?.PAYMENT_ABA_PAYWAY_CREDIT_CARD_ENABLED" class="information-section mx-auto content">
        <div class="option-wrapper">
            <div
                class="variant-wrapper checkbox label-as-h3 d-flex justify-content-between align-items-center theme-light mb-3">
                <label class="d-flex flex-column w-100 container mb-0 font-size-heading">
                    <div class="d-flex section-title theme-light">
                        {{'public.payment.paymentMethodSelection' | translate}}
                    </div>
                </label>
            </div>
        </div>

        <div *ngIf="storeSettings?.ABA_PAYWAY_PAYMENT_METHODS?.split('|')?.includes('ABAPAY')"
            class="radio-custom option-wrapper variant-wrapper radio d-flex justify-content-between align-items-center mx-3 my-2">
            <label class="d-flex flex-column w-100 container mb-0" for="abapay">
                <div class="row">
                    <div class="col-md-0 p-0 d-flex align-items-center"> {{'admin.store.payment.method.abapay' |
                        translate}}</div>
                    <div class="col pl-1">
                        <img src="assets/img/payment_logos/abapay-abapay.png" width="100%" style="max-width: 60px">
                    </div>
                </div>
                <input type="radio" id="abapay" [(ngModel)]="selectedOptionalPaymentMethod"
                    name="selectedOptionalPaymentMethod" value="ABAPAY" />
                <span class="checkmark"></span>
            </label>
        </div>
        <div *ngIf="storeSettings?.ABA_PAYWAY_PAYMENT_METHODS?.split('|')?.includes('CREDIT_CARD_VISA_MASTERCARD_JCB')"
            class="radio-custom option-wrapper variant-wrapper radio d-flex justify-content-between align-items-center mx-3 my-2">
            <label class="d-flex flex-column w-100 container mb-0" for="creditcard">
                <div class="row">
                    <div class="col-md-0 p-0 d-flex align-items-center"> {{'admin.store.payment.method.creditcard' |
                        translate}}</div>
                    <div class="col pl-1">
                        <img src="assets/img/payment_logos/abapay-creditcard.png" width="100%" style="max-width: 110px">
                    </div>
                </div>
                <input type="radio" id="creditcard" [(ngModel)]="selectedOptionalPaymentMethod"
                    name="selectedOptionalPaymentMethod" value="CREDIT_CARD_VISA_MASTERCARD_JCB" />
                <span class="checkmark"></span>
            </label>
        </div>
        <div *ngIf="storeSettings?.ABA_PAYWAY_PAYMENT_METHODS?.split('|')?.includes('KHQR')"
            class="radio-custom option-wrapper variant-wrapper radio d-flex justify-content-between align-items-center mx-3 my-2">
            <label class="d-flex flex-column w-100 container mb-0" for="khqr">
                <div class="row">
                    <div class="col-md-0 p-0 d-flex align-items-center"> {{'admin.store.payment.method.khqr' |
                        translate}}</div>
                    <div class="col pl-1">
                        <img src="assets/img/payment_logos/abapay-khqr.png" width="100%" style="max-width: 75px">
                    </div>
                </div>
                <input type="radio" id="khqr" [(ngModel)]="selectedOptionalPaymentMethod"
                    name="selectedOptionalPaymentMethod" value="KHQR" />
                <span class="checkmark"></span>
            </label>
        </div>
        <div *ngIf="storeSettings?.ABA_PAYWAY_PAYMENT_METHODS?.split('|')?.includes('WECHAT')"
            class="radio-custom option-wrapper variant-wrapper radio d-flex justify-content-between align-items-center mx-3 my-2x">
            <label class="d-flex flex-column w-100 container mb-0" for="wechat">
                <div class="row">
                    <div class="col-md-0 p-0 d-flex align-items-center"> {{'admin.store.payment.method.wechat' |
                        translate}}</div>
                    <div class="col pl-1">
                        <img src="assets/img/payment_logos/abapay-wechat.png" width="100%" style="max-width: 75px">
                    </div>
                </div>
                <input type="radio" id="wechat" [(ngModel)]="selectedOptionalPaymentMethod"
                    name="selectedOptionalPaymentMethod" value="WECHAT" />
                <span class="checkmark"></span>
            </label>
        </div>
        <div *ngIf="storeSettings?.ABA_PAYWAY_PAYMENT_METHODS?.split('|')?.includes('ALIPAY')"
            class="radio-custom option-wrapper variant-wrapper radio d-flex justify-content-between align-items-center mx-3 my-2x">
            <label class="d-flex flex-column w-100 container mb-0" for="alipay">
                <div class="row">
                    <div class="col-md-0 p-0 d-flex align-items-center"> {{'admin.store.payment.method.alipay' |
                        translate}}</div>
                    <div class="col pl-1">
                        <img src="assets/img/payment_logos/abapay-alipay.png" width="100%" style="max-width: 75px">
                    </div>
                </div>
                <input type="radio" id="alipay" [(ngModel)]="selectedOptionalPaymentMethod"
                    name="selectedOptionalPaymentMethod" value="ALIPAY" />
                <span class="checkmark"></span>
            </label>
        </div>
    </div>
    <div *ngIf="!isLoading && paymentData && isAmountRemaining"
        class="add-to-cart-wrapper d-flex flex-column w-100 mx-auto py-0 pt-3 px-1 font-size-primary text-unselectable">
        <div class="sticky-terms text-center my-1 px-1 font-size-secondary">{{'public.checkout.termsAndPolicy' |
            translate}}
            <a [href]="whitelabelService.getWhiteLabelTermsLink()  | safe " target="_blank"
                (click)="termsPrivacyComponent.openReadMoreModal($event, 'terms')">{{'public.checkout.termsOfUse' |
                translate}}</a>
            {{'public.checkout.acceptTerms.and' | translate}}
            <a [href]="whitelabelService.getWhiteLabelPrivacyLink() | safe" target="_blank"
                (click)="termsPrivacyComponent.openReadMoreModal($event, 'policy')">{{'public.checkout.privacyPolicy' |
                translate}}</a>
        </div>
        <a href="#" class="button dark d-block text-center py-3 mx-2 text-unselectable" id="proceed-payment"
            appPreventDoubleClick [throttleTime]="5000" (click)="proceedToPayment($event)">
            {{'public.payment.proceedToPayment' | translate}}
        </a>
    </div>
    <div *ngIf="!isAmountRemaining && !error && !errorOrders" class="mx-auto p-3 mb-0 pl-4 border-top order-paid">
        <div class="font-size-header font-weight-bold">{{'public.global.thankYou' | translate}}!</div>
        <div class="font-size-primary text-unselectable">{{'public.standalonepayment.paymentpage.orderPaid' |
            translate}}</div>
    </div>
 </div>
</div>
</div>
<form #jccForm class="checkout mx-2" action="{{jccServerLink}}" class="d-none" [hidden]="true" method="POST">
    <div class="variant-wrapper d-flex flex-column justify-content-start align-items-start mx-3 my-2"
        style="max-width: 100%;">
        <input type="hidden" name="Version" value="{{jccRequestJSON?.version}}">
        <input type="hidden" name="MerID" value="{{jccRequestJSON?.merchantId}}">
        <input type="hidden" name="AcqID" value="{{jccRequestJSON?.acquirerId}}">
        <input type="hidden" name="MerRespURL" value="{{jccRequestJSON?.responseUrl}}">
        <input type="hidden" name="MerCallbackURL" value="{{jccRequestJSON?.callbackUrl}}">
        <input type="hidden" name="PurchaseAmt" value="{{jccRequestJSON?.formattedPurchaseAmount}}">
        <input type="hidden" name="PurchaseCurrency" value="{{jccRequestJSON?.currency}}">
        <input type="hidden" name="PurchaseCurrencyExponent" value="{{jccRequestJSON?.currencyExponent}}">
        <input type="hidden" name="OrderID" value="{{jccRequestJSON?.orderId}}">
        <input type="hidden" name="CaptureFlag" value="{{jccRequestJSON?.captureFlag}}">
        <input type="hidden" name="Signature" value="{{jccRequestJSON?.signature}}">
        <input type="hidden" name="SignatureMethod" value="{{jccRequestJSON?.signatureMethod}}">
    </div>
</form>

<!-- PAY WITH TRUSTPAYMENTS -->
<app-trustpayment #trustpaymentComponent> </app-trustpayment>

<app-globalpay></app-globalpay>
<app-rms></app-rms>
<app-apcopay #apcopayComponent></app-apcopay>
<app-terms-privacy #termsPrivacyComponent></app-terms-privacy>